import { COOKIES } from '@bulknutrients/bulk-shared-lib/constants';
import { log, logBreadcrumb } from '@lib/logs';
import Cookies from 'js-cookie';
import useSWR from 'swr';

const getCookie = () => {
  const cook = Cookies.get(COOKIES.tracking);
  return cook;
};

const fetcher = async (input: RequestInfo, init?: RequestInit) => {
  const response = await fetch(input, init);
  const res = await response.json();

  if (!response.ok) {
    if (response.status === 400 || response.status === 401) {
      return null;
    }

    const error = new Error('Unable to fetch customer');
    (error as Error & { status?: number }).status = response.status;
    throw error;
  }

  if (res.data) {
    return res.data;
  }

  return null;
};

/**
 * This hook checks if the customer is an existing customer based on the uuid cookie and the database.
 * @returns isExisting - based on uuid existing in database,
 *  - hasVisitedSite - based on uuid cookie existing,
 *  - suspectedCustomerId if we have one in the database
 */
export const useCustomerStatus = (): {
  isExisting: boolean;
  hasVisitedSite: boolean;
  suspectedCustomerId: number | undefined;
  isLoading: boolean;
} => {
  const uuidCookieValue = getCookie();

  const { data, isLoading } = useSWR<{ id: number; uuid: string } | null>(
    `/api/customer/login/uuid?uuid=${uuidCookieValue}`,
    fetcher,
    {
      dedupingInterval: 500,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      onError: (error) => {
        logBreadcrumb({
          category: 'hooks',
          message: 'useCustomerStatus request',
          level: 'error',
        });

        log({ error: error, location: 'useCustomerStatus' });
      },
    }
  );

  return {
    isExisting: data?.id !== undefined && data?.uuid === uuidCookieValue,
    hasVisitedSite: uuidCookieValue !== undefined,
    suspectedCustomerId: data?.id,
    isLoading,
  };
};
